import React from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { IPayment } from '@/modules/payment/types';
import { AddPropertyField } from '@/modules/settings/property';
import { Typography } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Object from '~/images/shared/Object.svg';

const ArchivedFieldsBanner: React.FC<IPayment.IFieldsSchema> = ({
  activeFields,
  paidFields,
  freeSlots,
}) => {
  const { t } = useTranslation('payment');
  const [selectedAsset] = useStore((store) => store?.asset);
  const { openModal } = useModal();

  const handleAddField = () => {
    openModal(
      <AddPropertyField
        selectedAsset={selectedAsset}
        onSuccess={() => {
          toast.success(t('field-added-at-dashboard'));
        }}
      />,
      {
        variant: 'full',
      }
    );
  };

  return (
    <div className='flex items-center justify-between gap-2 rounded-xl bg-outline-default p-16'>
      <div className='flex items-center gap-2'>
        <span className='text-primary-400'>
          <Object />
        </span>
        <Typography variant='caption' className='text-primary-400'>
          {t('archived-fields-ux-writing', {
            ns: 'payment',
            paidFields,
            activeFields,
            freeSlots,
            paidFieldsCount: paidFields > 1 ? t('fields') : t('field'),
            activeFieldsCount: activeFields > 1 ? t('fields') : t('field'),
            freeSlotsCount: freeSlots > 1 ? t('fields') : t('field'),
          })}
        </Typography>
      </div>
      <div
        onClick={handleAddField}
        className='cursor-pointer text-base font-medium text-primary-400'
      >
        {t('add-new-field')}
      </div>
    </div>
  );
};

export { ArchivedFieldsBanner };
